import React, { Component } from "react";
import Modal from "react-modal";
import { Link,withRouter } from "react-router-dom";
import { message,Switch,Spin } from 'antd';
import AppService from '../service/app_service';
import AuthenticationService from "../service/authentication_service";

import { messaging } from "./../firebase/firebase";

let pushNotificationState = false;
class ChatList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSetPriceDialog: false,
      messages: [],
      activeDrags: 0,
      deltaPosition: {
        x: 0, y: 0
      },
      controlledPosition: {
        x: -400, y: 200
      },
      history: false,
      requestId: props.requestId ? props.requestId : 0, 
      loading :true,
    };
  }

  componentDidMount() {
    this.handlePermission();
    setTimeout(() => {
      this.scrollDown();
      Modal.setAppElement("#root");
    }, 100);


    if(this.props.requestId && this.props.requestId > 0){
        AppService.getPotentialSales(this.props.requestId).then(rec => {
            if(rec.error){
              AuthenticationService.clearLocalstorage();
            }else{
              this.setState({
                messages: rec.list, loading :false
              });
            }
          })
    }else{
        AppService.getChatBuyers().then(rec => {
            if(rec.error){
              AuthenticationService.clearLocalstorage();
            }else{
              this.setState({
                messages: rec.list, loading :false
              });
            }
          })
    }

    


    
  }

  scrollDown = () => {
    let shoppingListContainer = document.getElementById("chat-body");
    if (shoppingListContainer)
      shoppingListContainer.scrollTop = shoppingListContainer.scrollHeight;
  }

  handlePriceChange = (event) => {
    const { id, value } = event.target;
    this.setState({
      [id]: value,
    });
  };

  updatePrice = (event) => {
    event.preventDefault();
    this.setState({
      showSetPriceDialog: false,
    });
  };

  viewHistory = () => {
    this.setState({
      history: !this.state.history,
    });
  };


  toggleModal = () => {
    this.setState({
      showSetPriceDialog: !this.state.showSetPriceDialog,
    });
    this.props.close();
  };



  handleDrag = (e, ui) => {
    const { x, y } = this.state.deltaPosition;
    this.setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      }
    });
  };

  onStart = () => {
    this.setState({ activeDrags: ++this.state.activeDrags });
  };

  onStop = () => {
    this.setState({ activeDrags: --this.state.activeDrags });
  };

  // For controlled component
  adjustXPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { x, y } = this.state.controlledPosition;
    this.setState({ controlledPosition: { x: x - 10, y } });
  };

  adjustYPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { controlledPosition } = this.state;
    const { x, y } = controlledPosition;
    this.setState({ controlledPosition: { x, y: y - 10 } });
  };

  onControlledDrag = (e, position) => {
    const { x, y } = position;
    this.setState({ controlledPosition: { x, y } });
  };

  onControlledDragStop = (e, position) => {
    this.onControlledDrag(e, position);
    this.onStop();
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  startConvo  (data){
    message.success(data)
    AppService.getOrderById(data.requestId).then(rec => {
      rec.channel = data.channel;
      this.props.startConvo(rec);
    })
  }

   handlePermission() {
    return (navigator && navigator.permissions) && navigator.permissions
            .query({name:'notifications'})
            .then(this.permissionQuery)
            .catch(this.permissionError);
  }
   permissionError(error){
    console.log(error);
  }
   permissionQuery(result) {
    console.debug({result});
    var newPrompt;
  
    if (result.state == 'granted') {
        // notifications allowed, go wild
        console.log("granted")
        pushNotificationState = true;
    } 
    else if (result.state == 'prompt') {
        // we can ask the user
        console.log("prompt")
        //newPrompt = Notification.requestPermission();
        //alert("newPrompt");
  
    } 
    else if (result.state == 'denied') {
        // notifications were disabled
        console.log("denied")
        pushNotificationState = false;
    }
  
    result.onchange = () => console.debug({updatedPermission: result});
  
    return newPrompt || result;
  }

  switchChange(checked){
    console.log("switch",checked)
    if(checked){
      if (Notification.permission === "denied") {
        alert("Notifications blocked. Please enable notification in your browser.");
      }else{
        Notification.requestPermission();

        this.requestPerm();
      }
      
    }

  }
  async requestPerm(){
    if (messaging) {
      messaging.requestPermission()
          .then(async function () {
              const token = await messaging.getToken();
              console.log("Token = " + token)


              let localToken = AuthenticationService.getFcmToken();
              if (localToken !== token && AuthenticationService.getToken()) {
                  console.log("Setting new token")
                  AuthenticationService.setFcmToken(token);
                  let data = {};
                  data.fcm = token;
                  //data.userId = AuthenticationService.getId();
                  AppService.updateAccountFcm(data)
                      .then(response => {
                          if (response.code) {
                              AuthenticationService.setFcmToken(null);
                          } else {
                              // message.success("Token registration was successful")
                          }

                      })
                  pushNotificationState = true;
              } else {
                  console.log("Setting nothing")
              }

          })
          .catch(function (err) {
              console.log("Unable to get permission to notify.", err);
          });
      navigator.serviceWorker.addEventListener("message", (message) => console.log(message));

      messaging.onMessage((payload) => {
          console.log('Message received. ', payload);
          var noteTitle = payload.notification.title;
          var body = payload.notification.body;
          alert(body);
      });
  }
  }



  render() {
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
    const { messages,loading } = this.state;
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const that = this;

    if(Notification.permission === "granted")
      pushNotificationState = true;


    let friends = messages && messages.map((item, i) => {
      return  item.ref && <div className={"message received "} style={{zIndex: '9'}}  key={i} 

    //   onClick={() => AppService.getOrderById(item.requestId).then(rec => {
    //     rec.channel = item.channel;
    //     this.props.startConvo(rec);
    //   })}

      onClick={() => this.props.history.push("/transaction/detail/"+item.ref)}
      >
        <span id="random"   >B: {item.buyerUsername} - S: {item.sellerUsername} ({item.asset})</span>
        <span className="metadata"><span className="time" />{item.modifiedAt}</span>
        <span class="badger" style={{top: '-15px'}}>{item.messageCounter}</span>
        
      </div>
    })
    

    return (
      <div>
          <div id="whatsapp-chat" className="show">
            <div className="header-chat">
              <div className="head-home">
                <div className="info-avatar"><img src="https://icons-for-free.com/iconfiles/png/512/email+envelope+inbox+mail+message+send+icon-1320085879987098147.png" /></div>
                <p>
                  <span className="whatsapp-name">My Inbox</span><br /><small>B = Buyer, S = Seller</small>



                </p>
                <Switch checkedChildren="Enable push notification" unCheckedChildren="Enable push notification" defaultChecked={pushNotificationState} disabled={pushNotificationState} onChange={(e) => this.switchChange(e)} />


              </div>
              <div className="get-new hide">
                <div id="get-label" />
                <div id="get-nama" />
              </div>
            </div>
            
            <div className="home-chat">


            </div>
            <div className="start-chat" id="start-chat">
              <div className="chat-body" id="chat-body">


                <div className="chat-container">

                  
                  <div className="conversation">
                    <div className="conversation-container">
                    <Spin spinning={loading} size="large"  />
                      {friends}

                    </div>
                  </div>
                  


                </div>
              </div>

            </div>
            <div id="get-number" /><a className="close-chat" onClick={() => {
              this.props.close();
            }} >×</a>
          </div>
        {/* <a className='blantershow-chat'  title='Show Chat'><svg width="20" viewBox="0 0 24 24"><defs /><path fill="#eceff1" d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z" /><path fill="#4caf50" d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z" /><path fill="#fafafa" d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z" /></svg> 
        <h6>Price : 340</h6>, <h6>Quantity : 1200</h6> , <h6 style={{color: 'green', fontSize: '16px'}}>Total amount : 12,000.0</h6>
        </a> */}


      </div>
    );
  }
}

export default withRouter(ChatList);
